import { createFormHookContexts } from '@tanstack/react-form'

/**
 * Shared TanStack Form contexts for the entire app.
 *
 * These are used by our custom form + field components to access the
 * underlying TanStack Form APIs via context instead of props.
 *
 * See: https://tanstack.com/form/latest/docs/framework/react/guides/form-composition
 */
export const {
  fieldContext,
  useFieldContext,
  formContext,
  useFormContext,
} = createFormHookContexts()


